export var MuiButton = {
  styleOverrides: {
    root: function root(_ref) {
      var theme = _ref.theme;
      return {
        textTransform: 'inherit',
        borderRadius: theme.spacing(1),
        padding: "".concat(theme.spacing(1), " ").concat(theme.spacing(2)),
        fontSize: theme.typography.body1.fontSize,
        paddingTop: 11,
        paddingBottom: 11,
        fontWeight: 600
      };
    },
    outlined: {
      borderWidth: 2,
      '&:hover': {
        borderWidth: 2
      }
    }
  }
};
//# sourceMappingURL=MuiButton.js.map